import React from 'react';
import { avatarConfig, badgeConfig } from './../../../conf/config';
import ClickableIcon from './../ClickableIcon/ClickableIcon';

const Avatar = (props) => {

    let avatarImgPath = '#'
    if(avatarConfig.hasOwnProperty(props.avatarName)){
        avatarImgPath = avatarConfig[props.avatarName];
    }

    let editableIcon = '';
    let avatarAction = false;
    if(props.isEditable==='true' && typeof props.editableAction==='function'){
        editableIcon = <ClickableIcon class="edit-btn" />;
        avatarAction = true;
    }

    let badgeIcon = [];
    if ( typeof props.badgeUser !== 'undefined') {
        let currentBadge = '';
        for ( let badge of badgeConfig ) {
            if ( badge.pointsRequired > props.badgeUser ) {
                break;
            }
            currentBadge = badge.imgHover;
        }
        if ( currentBadge !== '' ) {
            badgeIcon = (<div className="badge-user" >
                <img src={currentBadge} alt='Ton badge' />
            </div>);

        }
    }

    return(
        <div className="avatar-container" onClick={avatarAction?props.editableAction:null}>
            {editableIcon}
            {badgeIcon}
            <img src={avatarImgPath} alt={`${props.userName} pic's`} onClick={(typeof props.imgClick === 'function' ) ?props.imgClick : null}></img>
        </div>
    );
};

export default Avatar;


// WEBPACK FOOTER //
// ./src/containers/UI/Avatar/Avatar.js